import { Navigate, useRoutes } from "react-router-dom";
import MainLayout from "./pages/MainLayout";
import CompanyDetailsPage from "./pages/companyStats/esopStats/CompanyDetailsPage";
import GlobalInvestorTable from "./pages/dashboard/GlobalInvestor";
import LoginPage from "./pages/login/loginPage";
import UploadWrapper from "./pages/onboarding/UploadWrapper";
import CreateOrder from "./pages/superAdmin/createOrder";
import MCAOrders from "./pages/superAdmin/mcaOrders";
import UserTable from "./pages/users/UserTable";
import { useAuthStore } from "./store";
import EsopStats from "./pages/companyStats/esopStats/EsopStats";
import CaptableStats from "./pages/companyStats/captableStats/CaptableStats";
import BillingDashboard from "./pages/billingPages/BillingDashboard";
import HissaUserTable from "./pages/hissaUsers/HissaUserTable";
import { GenerateCompanyExcelTable } from "./pages/GenerateCompanyExcel/GenerateCompanyExcelAGTable";
import { DataPipelinePage } from "./pages/dataPipeline/DataPipelinePage";

function getDefaultPath(role?: string) {
  if (role === "FinanceAdmin") return "/esopStats";
  if (role === "User") return "/dataPipeline";
  return "/onboarding";
}

export default function Router() {
  const { isAuthenticated, role } = useAuthStore();
  const defaultPath = getDefaultPath(role);

  const financeAdminChildren = [
    {
      path: "esopStats",
      element: <EsopStats />,
    },
    {
      path: "companyDetails",
      element: <CompanyDetailsPage />,
    },
    {
      path: "billingDetails",
      element: <BillingDashboard />,
    },
    {
      path: "*",
      element: <Navigate to={defaultPath} replace />,
    },
  ];

  const userChildren = [
    {
      path: "mcaCreatedOrder",
      element: <MCAOrders />,
    },
    {
      path: "dataPipeline",
      element: <DataPipelinePage />,
    },
    {
      path: "upload",
      element: <UploadWrapper />,
    },
    {
      path: "*",
      element: <Navigate to={defaultPath} replace />,
    },
  ];

  const defaultChildren = [
    {
      path: "users",
      element: <UserTable />,
    },
    {
      path: "hissaUsers",
      element: <HissaUserTable />,
    },
    {
      path: "onboarding",
      element: <GenerateCompanyExcelTable />,
    },
    {
      path: "upload",
      element: <UploadWrapper />,
    },
    {
      path: "esopStats",
      element: <EsopStats />,
    },
    {
      path: "captableStats",
      element: <CaptableStats />,
    },
    {
      path: "globalInvestor",
      element: <GlobalInvestorTable />,
    },
    {
      path: "createOrder",
      element: <CreateOrder />,
    },
    {
      path: "mcaCreatedOrder",
      element: <MCAOrders />,
    },
    {
      path: "companyDetails",
      element: <CompanyDetailsPage />,
    },
    {
      path: "billingDetails",
      element: <BillingDashboard />,
    },
    {
      path: "dataPipeline",
      element: <DataPipelinePage />,
    },
    {
      path: "*",
      element: <Navigate to={defaultPath} replace />,
    },
  ];

  const children =
    role === "FinanceAdmin"
      ? financeAdminChildren
      : role === "User"
        ? userChildren
        : defaultChildren;

  return useRoutes([
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/",
      element: (
        <Navigate to={isAuthenticated ? defaultPath : "/login"} replace />
      ),
    },
    {
      path: "/",
      element: isAuthenticated ? (
        <MainLayout />
      ) : (
        <Navigate to="/login" replace />
      ),
      children,
    },
    {
      path: "*",
      element: (
        <Navigate to={isAuthenticated ? defaultPath : "/login"} replace />
      ),
    },
  ]);
}
